// extracted by mini-css-extract-plugin
module.exports = {"info":"CovidTestInfo_info__11eq7","detail":"CovidTestInfo_detail__16HqV"};